import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from "react";
import Icon from "../../../../../../../base/icons/icon/index.js";
import PriceWithCurrency from "../../../../../../../base/text/price-with-currency/index.js";
import { normalizePrice } from "../../../../utils/index.js";
import contextBabylon from "../../../../../../../../context/index.js";
import { formatPriceWithCurrency } from "../../../../../../../../helpers/currency/index.js";
import * as S from "./styled.js";
const PriceModal = (props)=>{
    const { literals  } = props;
    const price = normalizePrice(props.price);
    const { Currency , Language  } = useContext(contextBabylon);
    const priceProps = {
        price: price.value,
        currency: Currency,
        locale: Language
    };
    return /*#__PURE__*/ _jsx(S.InfoPrice, {
        "data-testid": "PriceModal",
        children: price?.value && price.value != 0 ? /*#__PURE__*/ _jsxs(S.PriceAmounts, {
            children: [
                /*#__PURE__*/ _jsxs(S.PriceTop, {
                    children: [
                        price.from && /*#__PURE__*/ _jsx("span", {
                            className: "from",
                            children: literals.fromCaption
                        }),
                        price.market_value && /*#__PURE__*/ _jsx("span", {
                            className: "old-price",
                            children: formatPriceWithCurrency(price.market_value, Currency, Language)
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(S.PriceCurrent, {
                    children: /*#__PURE__*/ _jsx(PriceWithCurrency, {
                        props: priceProps
                    })
                }),
                literals.perPerson && !price.paxValue && /*#__PURE__*/ _jsx("span", {
                    className: "per-person",
                    children: literals.perPerson
                }),
                price.paxValue && /*#__PURE__*/ _jsxs(S.PricePaxValue, {
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "per-person",
                            children: literals.perPerson
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            children: formatPriceWithCurrency(price.paxValue, Currency, Language)
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ _jsx(Icon, {
            className: "nico-magnifier"
        })
    });
};
export default PriceModal;

//# sourceMappingURL=index.js.map